import axios from '../index'
import { LOGIN_USER } from './login.constants'
import { User, UserLoginPayload, UserLoginResponse } from './login.types'

export const loginUser = (payload: UserLoginPayload) => axios.post<UserLoginResponse>(LOGIN_USER.LOGIN_USER, payload)

export const getUserDetails = () => axios.get<User>(LOGIN_USER.CURRENT_USER)
